import { useAccessibility } from "../../providers/accessibility-hooks";
import { DesktopContainer } from "./style";
import { ActionsContainer } from "./ActionsContainer";
import { useToggleVLibras } from "./hooks/toggle-libras";

export const DesktopAccessibilityButtons = () => {
  const { increaseFonts, decreaseFonts, toggleContrast } = useAccessibility();
  const { toggleVLibras } = useToggleVLibras();

  const handleActionClick = (action: () => void) => {
    action();
  };

  return (
    <DesktopContainer id="accessibility-buttons">
      <ActionsContainer
        increaseFonts={increaseFonts}
        decreaseFonts={decreaseFonts}
        toggleContrast={toggleContrast}
        handleToggleVLibras={toggleVLibras}
        onActionClick={handleActionClick}
        variant="desktop"
      />
    </DesktopContainer>
  );
};
